<template>
	<CardSlashed>
		<template #left>
			<div v-if="userIsSubscribed" class="card-blue-side">
				<div class="card-title">
					<div class="icon-plugins" v-html="getIcon('iconPlugins')"></div>
					<h2>{{ getString("marketplace_card_title") }}</h2>
				</div>
				<div class="card-subtitle">
					<p>{{ getString("marketplace_card_subtitle_subscribed", [userStore.menuWord]) }}</p>
					<br>
					<p v-show="userStore.currSubscription === 'base'" v-html="getString('new_subs_explanation')"></p>
				</div>
				<div class="row flex-start align-start">
					<div class="icon-base-container">
						<div class="icon-base" v-html="getIcon('iconQromoBase')"></div>
					</div>
				</div>
			</div>
		</template>
		<template #right>
			<div v-if="userIsSubscribed" class="card-white-side">
				<div class="row">
					<div class="col-12">
						<div class="row breakdown-row">
							<div class="breakdown-row-left">
								<h3 class="mb-3">{{ getString('active_subscriptions') }}</h3>
							</div>
						</div>
						<div class="row breakdown-row">
							<div class="breakdown-row-left pb-10">
								<p v-if="userStore.currSubscription">{{ getString('qromo_'+userStore.currSubscription) }}</p>
							</div>
						</div>
						<div v-if="userStore && (userStore.currPlans['order_pay'] || userStore.currPlans['delivery'] || userStore.currPlans['takeaway'] || userStore.currPlans['pos'])" class="row breakdown-row">
							<div class="breakdown-row-left">
								<h3 class="mb-3">{{getString('features')}}</h3>
							</div>
						</div>
						<div v-if="userStore && userStore.currPlans['order_pay']" class="row breakdown-row">
							<div class="breakdown-row-left">
								<p>+ {{ getString('order_and_pay') }}</p>
							</div>
						</div>
						<div v-if="userStore && userStore.currPlans['counter']" class="row breakdown-row">
							<div class="breakdown-row-left">
								<p>+ {{ getString('counter') }}</p>
							</div>
						</div>
						<div v-if="userStore && userStore.currPlans['pay_bill']" class="row breakdown-row">
							<div class="breakdown-row-left">
								<p>+ {{ getString('pay_bill') }}</p>
							</div>
						</div>
						<div v-if="userStore && userStore.currPlans['delivery']" class="row breakdown-row">
							<div class="breakdown-row-left">
								<p>+ {{ userStore.deliveryWord }}</p>
							</div>
						</div>
						<div v-if="userStore && userStore.currPlans['takeaway']" class="row breakdown-row">
							<div class="breakdown-row-left">
								<p>+ {{ userStore.takeawayWord }}</p>
							</div>
						</div>
						<div v-if="userStore && userStore.currPlans['pos']" class="row breakdown-row">
							<div class="breakdown-row-left">
								<p>+ {{ getString('pos') }}</p>
							</div>
						</div>
						<div v-if="userStore && userStore.currPlans['counter']" class="row breakdown-row">
							<div class="breakdown-row-left">
								<p>+ {{ getString('counter') }}</p>
							</div>
						</div>
						<div v-if="userStore?.currSubscription && ['allinone', 'enterprise'].includes(userStore.currSubscription)" class="row breakdown-row">
							<div class="breakdown-row-left">
								<p>+ {{ getString('kitchen_monitor') }}</p>
							</div>
						</div>
						<div v-if="userStore && (userStore.currPlans['order_and_pay'] || userStore.currPlans['delivery'] || userStore.currPlans['takeaway'] || userStore.currPlans['pay_bill'] || userStore.currPlans['pos'] || userStore.currPlans['counter'] || (userStore?.currSubscription && ['allinone', 'enterprise'].includes(userStore.currSubscription)))" class="row breakdown-row mt-5">

						</div>
					</div>
					<div class="col-12 align-end pt-20">
						<AppButton @click="$emit('go-to-portal')" :small="windowWidth <= 540" outline :loading="loading || loadingSub" :text="getString('my_costs')" />
						<AppButton v-if="userStore.currSubscription !== 'base' && userStore?.currSubscription !== 'enterprise'" class="mt-8" @click="$emit('update-billing-cycle')" :small="windowWidth <= 540" :loading="loading || loadingSub" :text="switchBillingText" />
						<AppButton v-if="userStore.currSubscription === 'base'" class="mt-8" @click="$emit('switch-to-new-plan', 'allinone')" :small="windowWidth <= 540" :loading="loading || loadingSub" :text="getString('switch_new_subscription')" />
					</div>
				</div>
			</div>
		</template>
	</CardSlashed>
</template>

<script>
import AppTextInput from "@/shared/components/AppTextInput.vue";
import AppButton from "@/shared/components/AppButton.vue";
import CardSlashed from "@/console-new/components/shared/CardSlashed.vue";
import {useLanguageStore, useNotificationStore, useSvgStore} from "@/shared/stores";
import {useUserStore} from "@/console-new/stores";

import WindowWidth from "@/console-new/mixins/WindowWidth";

export default {
	setup() {
		let languageStore = useLanguageStore();
		let userStore = useUserStore();
		let svgStore = useSvgStore();
		let notificationStore = useNotificationStore();
		return {languageStore, getString: languageStore.getString, showNotification: notificationStore.showNotification, getIcon: svgStore.get, userStore}
	},
	emits: ["go-to-portal", "switch-to-new-plan", "update-billing-cycle"],
	mixins: [WindowWidth],
	name: "MarketplaceCardSlashed",
	components: {CardSlashed, AppTextInput, AppButton},
	props: {
		marketplaceItems: {
			type: Array,
			default: () => []
		},
		billingCycle: {
			type: Number,
			default: 0
		},
		loadingSub: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			loading: false,
		}
	},
	computed: {
		switchBillingText() {
			return this.billingCycle === 0 ? this.getString('switch_to_monthly') : this.getString('switch_to_yearly');
		},
		userIsSubscribed() {
			return this.userStore?.currSubscription && this.userStore?.currBusiness?.plan_id;
		},
	},
	methods: {

	}
}
</script>

<style lang="scss" scoped>
.card-blue-side {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
	padding: 10px 0 10px 10px;

	.card-title {
		width: 100%;
		display: flex;
		align-items: flex-start;
		justify-content: flex-start;
		margin-bottom: 10px;

		.icon-plugins {
			display: inline-block;
			width: 15px;
			margin-top: 4px;

			&:deep(svg) {
				.fill { fill: var(--color-txt-white); }
				.stroke { stroke: var(--color-txt-white); }
			}
		}
		h2 {
			font-size: 18px;
			display: inline-block;
			width: calc(100% - 15px);
			padding-left: 8px;
			color: var(--color-txt-white);
		}
		&.no-icon {
			h2 {
				width: 100%;
				padding-left: 0;
			}
		}
	}
	.card-subtitle {
		p {
			color: var(--color-txt-white);
			opacity: .75;
			font-size: 14px;
			line-height: 18px;
		}
	}
	.icon-base-container {
		@include centered;
		margin-top: 30px;

		.icon-base {
			@include centered;
			border-radius: 13px;
			width: 60px;
			height: 60px;
			background: transparent linear-gradient(225deg, var(--color-secondary) 0%, var(--color-primary) 100%) 0% 0% no-repeat padding-box;
			box-shadow: 0 3px 10px rgba(0, 0, 0, 0.40);

			&:deep(svg) {
				width: 30px;
				height: 30px;
				.fill { fill: var(--color-bg); }
				.stroke { stroke: var(--color-bg); }
			}
		}
	}
}
.card-white-side {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
	padding: 10px 10px 10px 0;

	&.no-sub {
		align-items: center;
		justify-content: center;
	}


	h3 {
		color: $primary;
		font-size: 16px;
		font-style: italic;
	}
	p {
		color: $primary;
		font-size: 14px;
		line-height: 22px;
	}

	small {
		font-size: 12px;
		line-height: 14px;
		color: $primary;
	}

	.breakdown-row {
		position: relative;

		.breakdown-row-left, .breakdown-row-right {
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			justify-content: flex-start;
		}

		.breakdown-row-left {
			width: calc(100% - 130px);
			padding-right: 10px;
		}
		.breakdown-row-right {
			position: relative;
			width: 130px;
			padding-left: 10px;

			&:after {
				@include pseudoLine(100%, 1px, 0, 0, $alpha_4);
			}
		}

		&:last-of-type {

			.breakdown-row-left {
				justify-content: flex-start;
				padding-top: 10px;

				h3 {
					font-style: normal;
					font-size: 14px;
				}
			}
			.breakdown-row-right {
				padding-top: 10px;
				justify-content: flex-end;

				p { line-height: 18px; }
			}

			&:after {
				@include pseudoLine(1px, 100%, 0, 0, $alpha_4);
			}
		}
	}

}

@media (max-width: 1200px) {
	.card-white-side .breakdown-row {
		.breakdown-row-left {
			width: calc(100% - 100px);
		}
		.breakdown-row-right {
			width: 100px;
		}
	}
}

@media (max-width: 768px), (min-width: 921px) and (max-width: 1080px) {
	.card-blue-side {
		padding: 10px 20px 10px 10px;
		.icon-base-container {
			margin-top: 10px;
		}
	}
	.card-white-side {
		padding: 20px 10px 10px 10px;
	}
}
@media (max-width: 500px) {
	.card-blue-side {
		padding: 0 10px 0 0;
		.icon-base-container .icon-base {
			width: 44px;
			height: 44px;
			&:deep(svg) {
				width: 24px;
				height: 24px;
			}
		}
	}
	.card-white-side {
		padding: 0;
	}
}
@media (max-width: 420px) {
	.card-blue-side, .card-white-side {
		@include wordWrap;
	}
}
@media (max-width: 380px) {
	.card-white-side .breakdown-row {
		.breakdown-row-left {
			width: calc(100% - 80px);
		}
		.breakdown-row-right {
			width: 80px;
		}
	}
}


.features-container {
	display: flex;
	flex-direction: column;
	width: 100%;
	position: relative;
	align-items: flex-start;
	align-self: stretch;

	.icon-tick {
		width: 14px;

		&:deep(svg)	{
			width: 100%;
			height: 14px;
			fill: var(--color-primary)!important;
			stroke: var(--color-primary)!important;
		}
	}
	p {
		padding-left: 5px;
		font-size: 12px;
		line-height: 16px;
		margin-bottom: 2px;
		max-width: calc(100% - 14px);
	}
	h4 {
		color: $primary;
		font-size: 12px;
		font-style: italic;
	}

	&.no-after {
		width: 100%;

		&:after { display: none; }
	}

}

.line-divider {
	width: 100%;
	height: 1px;
	background: $alpha_4;
	margin-bottom: 14px;
}

.button-container {
	display: flex;
	align-items: center;


	.price-value-container {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: center;
		margin-left: 10px;

		.price-value {
			display: flex;
			align-items: center;

			.price {
				font-weight: 700;
				font-size: 17px;
				position: relative;
			}

			.gratis {
				font-weight: 700;
				font-size: 14px;
				margin-left: 5px;
				color: $primary;
				text-transform: uppercase;
				position: relative;
			}
		}

		small {
			position: relative;
		}


		&.slashed {

			.price-value {
				.price {
					color: rgb(145,168,206);

					&:after {
						content: '';
						position: absolute;
						top: 50%;
						left: 0;
						width: 100%;
						height: 2px;
						background:var(--color-primary);
					}
				}
			}

			small {
				color: rgb(145,168,206);

				&:after {
					content: '';
					position: absolute;
					top: 50%;
					left: 0;
					width: 100%;
					height: 1px;
					background: var(--color-primary);
				}
			}

		}
	}


}
</style>